import { useContext } from 'react';
import styles from '../style.module.css';
import { filterDataContext } from '../FilterDataProvider';
import FilterBackButton from './FilterBackButton';

export default function SaveAsMenu() {
   let {
      extendMenu,
      setExtendMenu,
      setExtendedName,
      setOverideWithState,
      getListOfAvalibleFilters,
      setCurrentFilter,
   } = useContext(filterDataContext);

   let avalibleFilters = getListOfAvalibleFilters();

   return (
      <>
         {extendMenu ? (
            <ul>
               {avalibleFilters.map((filter, i) => {
                  if (filter === 'buffer') return;
                  return (
                     <li
                        className={`text-center hover:cursor-pointer p-2 0 green-button-on-hover ${
                           i === 0 ? 'mt-1' : ''
                        }`}
                        key={i}
                        onClick={() => {
                           setExtendMenu(!extendMenu);
                           setExtendedName('Save As');
                           setCurrentFilter(filter);
                        }}
                     >
                        {filter}
                     </li>
                  );
               })}
            </ul>
         ) : (
            <></>
         )}
         <div className={`my-2 w-max mx-auto ${styles.Save_Filter_Text}`}>
            {/* <SlButton onClick={() => {}}>Delete All</SlButton> */}
         </div>{' '}
      </>
   );

   /* function checkFilterdDataForClicks(filter) {
      if (!filter) return false;
      for (let i = 0; i < filter.length; i++) {
         let current = filter[i];
         let currentCacheFilter = filterCache[i];
         if (!deepEqual(current, currentCacheFilter)) return true;
      }
      return false;
   } */
}
